import { useContext } from 'react';
import { Grid, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { footerStyles as styledClasses } from './FooterStyles';
import { FOOTER_MSG, FOOTER_KEY, LIBRE_AHORRA_BUNDLE } from '../../constants';
import { productTypeMapping } from '../../services/productTypeMapping';
import LeadGenerationContext from '../../context/LeadGenerationContext';
import {
  commonTernary,
  isBundle,
  isCDIraproduct,
  isIRAEducativaProduct,
  isSimilarIRAProducts,
} from '../commonCode';
import { productMapping } from '../../services/productMapping';

const Footer = () => {
  const { t } = useTranslation();
  const { productType, productName, flowTypeVerifyScreen, currentPage, isLightTheme } =
    useContext(LeadGenerationContext);
  const currentYear = new Date().getFullYear();
  const isEducativaOffer =
    isIRAEducativaProduct(productName) && currentPage === 'certificate-of-deposit-ira';

  const bundleFooter = () => (
    <Grid
      container
      sx={{
        ...styledClasses.bundle_footer,
        paddingBottom:
          isBundle(productName) &&
          currentPage !== 'thankyou-bundle-automated' &&
          currentPage !== 'thank-you-bundle'
            ? '0'
            : '48px',
        '@media (max-width:600px)': {
          padding: '15px 0px',
        },
      }}
    >
      <span style={styledClasses.libreBundle_text}>
        {`© ${currentYear} `}
        {t('Footer', {
          defaultValue: 'Footer',
        })}
      </span>
    </Grid>
  );

  const defaultFooter = () => (
    <Box component="footer" sx={styledClasses.footer_position}>
      <Grid
        container
        sx={{
          ...styledClasses.footer,
          ...((isCDIraproduct(productName) || isEducativaOffer) && {
            background: 'transparent',
            height: '48px',
          }),
        }}
      >
        <Box
          tabIndex="-1"
          sx={{
            ...styledClasses.copyrights_text,
            ...(isSimilarIRAProducts(productName) && {
              font: 'normal normal normal 12px/16px Arial',
              fontWeight: '400',
            }),
          }}
          title="footerDescription"
        >
          {`© ${currentYear} `}
          {productTypeMapping(productType) === 'Credit'
            ? t('Oriental. All Rights Reserved.', {
                defaultValue: 'Oriental. All Rights Reserved.',
              })
            : isSimilarIRAProducts(productName)
            ? t('Oriental. All Rights Reserved. FDIC Member.', {
                defaultValue: 'Oriental. All Rights Reserved. FDIC Member.',
              })
            : t(FOOTER_KEY, {
                defaultValue: FOOTER_MSG,
              })}
        </Box>
      </Grid>
    </Box>
  );
  const footer = commonTernary(
    isBundle(productName) || flowTypeVerifyScreen === 'bundleLoginScreen',
    bundleFooter(),
    defaultFooter()
  );

  return footer;
};

export default Footer;
